export function loadScript() {
  if (!document.getElementById('AwsChallengeScript')) {
    const AwsChallengeScript = document.createElement('script')
    AwsChallengeScript.id = 'AwsChallengeScript'
    AwsChallengeScript.async = false
    AwsChallengeScript.src = import.meta.env.VITE_CHALLENGE_URL
    document.head.appendChild(AwsChallengeScript)
  }

  if (document.getElementById('AwsWAFScript')) return

  const AwsWafScript = document.createElement('script')
  AwsWafScript.id = 'AwsWAFScript'
  AwsWafScript.async = false
  AwsWafScript.src = import.meta.env.VITE_JSAPI_URL
  document.head.appendChild(AwsWafScript)
}

export function captchaFetch() {
  document.body.style.cursor = 'wait'
  const modalOverlay = document.getElementById('modalOverlay')
  const modal = document.getElementById('modal')
  if (modalOverlay && modal) {
    modalOverlay.style.display = 'block'
    modal.style.display = 'block'
  }

  return new Promise((resolve) => {
    window.shouldShowCaptcha = false
    window.AwsWafCaptcha.renderCaptcha(document.getElementById('captchaForm'), {
      onSuccess: async (token: any) => {
        if (modalOverlay && modal) {
          modalOverlay.style.display = 'none'
          modal.style.display = 'none'
        }

        resolve(token)
      },
      onLoad: () => {
        document.body.style.cursor = 'default'
      },
      onError: () => {
        if (modalOverlay && modal) {
          modalOverlay.style.display = 'none'
          modal.style.display = 'none'
        }
        resolve(null)
      },
      apiKey: import.meta.env.VITE_WAF_API_KEY,
    })
  })
}
